x<template>
  <div>
    <div v-if="!user.isProvider">
      <div class="filter">
        <el-row>
          <el-col :span="6">
            <el-input placeholder="Buscar" v-model="searchQuery" @input="sendFilterResponse"></el-input>
            </el-col>
          </el-row>
        </div>
    </div>
    <div v-if="!user.isProvider && provMessages.length > 0">
      <el-dialog :title="'Mensajes de ' + message.name" :visible.sync="showModalMessage" width="90%" :fullscreen="true" :lock-scroll="true" v-on:close="this.closeMessage" v-on:opened="updateChat('messages-container')">
        <div class="box-body messages-container" style="max-height: 100%; overflow:auto" id="messages-container">
          <tr v-for="msg in conversation" :key="msg.idMessage" style="width: 100%; float: right;" :id="msg.idMessage">
            <div :class="{'messages-rec': msg.idEmisor !== idUser,  'messages-env': msg.idEmisor === idUser}">
              <div v-if="msg.idEmisor !== idUser" style="font-weight: 600;">
                {{ msg.senderType }} - {{ '\n' + msg.sender}} 
              </div>
              <span v-html="formatMessage(msg.message)"></span>
              <span style="float: right; padding-left: 15px; font-size: 10px; opacity: 0.8; padding-top: 3px;">
                {{ formatDate(msg.date) }} 
                <i v-if="msg.idEmisor === idUser && msg.status === '0'" class="el-icon-more-outline"/>
                <i v-if="msg.idEmisor === idUser && msg.status === '1'" class="el-icon-view"/>
              </span>
            </div>
          </tr>
        </div>
        <span slot="footer" class="dialog-footer">
          <textarea class="form-control" rows="3" v-on:keyup.enter="sendMessage(message.idUser)" @click="updateMsgStatus(message.idUser, 1)" v-model="newMessage" style="width: calc(100% - 100px); margin-top: -30px; float:left; resize:none;" maxlength="255"></textarea>
          <button class="btn btn-primary" @click="sendMessage(message.idUser)">
            Enviar 
            <i class="el-icon-arrow-right" v-if="!loadingMsg"/>
            <i class="el-icon-loading" v-if="loadingMsg"/>
          </button>
        </span>
      </el-dialog>
      <el-dialog title="Envio de mensaje masivo" :visible.sync="showModalMassiveMessage" width="90%" :fullscreen="false" :lock-scroll="true" v-on:close="showModalMessage = false" v-on:opened="updateScroll('messages-container')">
        <el-row>
          <el-col :span="24">
            <textarea rows="15" v-model="newMessage" style="width: calc(100% - 1px); margin-top: -30px; float:left; resize:none;"></textarea>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <button class="btn btn-primary" style="float:right; margin-top: 1%" :disabled="newMessage.length <= 0" @click="sendMassiveMessage(providersSelected)"> Enviar Mensaje</button>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog top="10px" title="Seleccionar Destinatarios" :visible.sync="showModalMassiveMessageRecipients" width="50%" height="50%" :fullscreen="false" :lock-scroll="true" v-on:close="showModalMessage = false">
        <div>
            <el-row>
                <el-col :span="6" style="float:right">
                    <el-input placeholder="CUIT / Nombre" v-model="filtersRubro[1].value"></el-input>
                </el-col>
            </el-row>
        </div>
        <data-tables :data="contacts" class="table-responsive" :pagination-props="{ pageSizes: [10, 20, 30] }" :filters="filtersRubro">
            <el-table-column width="55">
                <template slot-scope="scope">
                    <input type="checkbox" v-model="providersSelected" :value="scope.row.idUser" />
                </template>
            </el-table-column>
            <el-table-column property="name" label="Nombre">
            </el-table-column>
            <el-table-column property="user" label="Email">
            </el-table-column>
            <el-table-column property="company" label="Compañia">
            </el-table-column>
        </data-tables>
        <el-button type="primary" :disabled="providersSelected.length <= 0" style="margin-top:20px; float: right" @click="openMassiveMessage()">
          Siguiente
        </el-button>
      </el-dialog>
      <section class="content">
        <div class="box-body">
          <div class="">
            <div style="margin-bottom: 10px">
              <el-row>
                <el-col :span="0">
                  <p></p>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" @click="selectMassiveMessageRecipients()" >Enviar mensaje masivo</el-button>
                </el-col>
              </el-row>
            </div>
            <data-tables-server :data="this.providersMessages" :filters="filters" :pagination-props="{ pageSizes: [10, 20, 30], currentPage:this.currentPage}" @query-change="loadData" :total="this.$store.state.contacts.length">
              <el-table-column :prop="'email'" :align="'center'" :label="'Usuario'" sortable="custom">
              </el-table-column>
              <el-table-column :align="'center'" label="Mensaje">
                <template slot-scope="scope" v-if="scope.row.messages.length > 0">
                    {{getMostRecentMessage(scope.row.messages).message }}
                </template>
              </el-table-column>
              <el-table-column :label="'Fecha'" :align="'center'" width="100px">
                <template slot-scope="scope" v-if="scope.row.messages.length > 0">
                  {{ formatDate(getMostRecentMessage(scope.row.messages).date) }}
                </template>
              </el-table-column>
              <el-table-column :align="'center'" :label="'Estado'" width="100px">
                <template slot-scope="scope" v-if="scope.row.messages.length > 0">
                  {{ getMostRecentMessage(scope.row.messages).status === '0' ? getMostRecentMessage(scope.row.messages).idEmisor === idUser ? 'Enviado' : 'Recibido' : 'Visto' }}
                </template>
              </el-table-column>
              <el-table-column label="" :align="'center'" style="" width="100px">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="Ver" placement="top"> 
                      <el-button type="primary" icon="el-icon-view" circle @click="seeMessage(scope.row)"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </data-tables-server>
          </div>
        </div>
      </section>
    </div>
    <div v-if="user.isProvider && myMessages.length > 0">
      <section class="content">
        <div class="box-body">
          <div class="box-body messages-container" style="max-height: 100%; overflow:auto; height: calc(100vh - 230px)" id="messages-container">  
            <tr v-for="msg in myMessages" :key="msg.idMessage" style="width:100%; float: right;">
              <div  v-bind:class="{'messages-rec': msg.idEmisor !== idUser,  'messages-env': msg.idEmisor === idUser}">
                <div v-if="msg.idEmisor !== idUser" style="font-weight: 600;">
                  {{ msg.senderType }} - {{ msg.sender}} 
                </div>
                {{formatMessage(msg.message)}}
                <span style="float: right; padding-left: 15px; font-size: 10px; opacity: 0.8; padding-top: 3px;"> 
                  {{ formatDate(msg.date) }} 
                  <i v-if="msg.idEmisor === idUser && msg.status === '0'" class="el-icon-more-outline"/>
                  <i v-if="msg.idEmisor === idUser && msg.status === '1'" class="el-icon-view"/>
                </span>
              </div>
            </tr>
          </div>
          <div class="messages-footer" >
            <textarea class="form-control"  v-on:keyup.enter.prevent="sendMessage(0)" @click="updateMsgStatus(idUser, 2)" rows="3" v-model="newMessage" style="width: calc(100% - 100px); float:left; resize:none;" maxlength="255"></textarea>
            <button class="btn btn-primary" @click="sendMessage(0)" style="margin-top: 20px; float:right; margin-right: 7px">
              Enviar 
              <i class="el-icon-arrow-right" v-if="!loadingMsg"/>
              <i class="el-icon-loading" v-if="loadingMsg"/>
            </button>
          </div>
        </div>
      </section>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  require('moment')
  // import $ from 'jquery'
  import datepicker from 'vue-date-picker'
  import api from '../../api'
import { mapState } from 'vuex'

  export default {
    name: 'Settings',
    components: {
      datepicker
    },
    data (router) {
      return {
        section: 'AllComments',
        loading: '',
        rubros: [],
        showModalMessage: false,
        showModalMassiveMessage: false,
        providersParaCompulsa: [],
        showModalMassiveMessageRecipients: false,
        message: '',
        searchQuery: '',
        loadMessagesFlag: false,
        currentPage: 1,
        pageSize: 20,
        timmerMessage: 0,
        conversation: null,
        loadingMsg: false,
        providersSelected: [],
        providersMessages: [],
        idProvider: null,
        newMessage: '',
        messageLength: 0,
        oldMessageLength: 0,
        idUser: this.$store.state.user.idUser,
        titles: [{                      // Columnas que se van a mostrar
          prop: '',
          label: 'Compañía',
          align: 'center'
        },
        {
          prop: 'cuit',
          label: 'CUIT',
          align: 'center'
        }],
        filtersRubro: [
          {
            prop: ['idRubro'],
            value: '',
            filterFn: (row, filterItem) => {
              return row.rubros.some(el => filterItem.value.includes(el.idRubro))
            }
          },
          {
            prop: ['cuit', 'company'],
            value: ''
          }
        ],
        filters: [{
          prop: ['email'],
          value: ''
        },
        {
          prop: ['userStatus'],
          value: '2'
        }],
        actionCol: {
          label: 'Acciones',
          props: {
            align: 'center'
          },
          buttons: [{
            props: {
              type: 'primary',
              icon: 'el-icon-view',
              circle: true
            },
            handler: row => {
              this.verMensaje(row)
            }
          }]
        }
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      datetime () {
        return new Date()
      },
      providers () {
        return this.$store.state.providers
      },
      contacts () {
        return this.$store.state.contacts.slice().sort((a, b) => { return a.status - b.status })
      },
      provMessages () {
        if (this.conversation !== null && this.loadMessagesFlag) {
          setTimeout(() => { this.conversation = this.$store.state.provMessages.find(el => el.idUser === this.message.idUser).messages.sort(this.orderByDate) }, 1)
          // setTimeout(() => this.updateScroll('messages-container'), 1)
        }
        this.providersMessages = this.$store.state.provMessages
        return this.$store.state.provMessages
      },
      myMessages () {
        if (this.$store.state.messages.length > 0) {
          setTimeout(() => this.updateScroll('messages-container'), 1)
        }
        return this.$store.state.messages
      }
    },
    methods: {
      sendFilterResponse () {
        this.$parent.checkComments(1, 20, this.searchQuery)
      },
      async loadData (queryInfo) {
        this.loading = true
        this.pageSize = queryInfo.pageSize
        this.currentPage = queryInfo.page
        this.conversation = null
        this.$parent.checkComments(this.currentPage, this.pageSize)
      },
      updateChat (id) {
        let messageLengthValue = this.conversation.length
        if (this.conversation.length > 0) {
          if (this.conversation[0].idEmisor !== this.idUser) {
            this.idProvider = this.conversation[0].idEmisor
          }
          if (this.conversation[0].idReceptor !== this.idUser) {
            this.idProvider = this.conversation[0].idReceptor
          }
          this.timmerMessage = setInterval(() => {
            this.getProviderMessages(this.idProvider)
            if (messageLengthValue !== this.messageLength) {
              this.$parent.checkComments()
              messageLengthValue = this.messageLength
            }
          }, 1000 * 3)
          this.updateScroll(id)
        }
      },
      getRubros () {
        api.request('GET', 'api/generic/rubros')
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          if (data) {
            this.rubros = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
      },
      getProviderMessages (idProvider) {
        api.request('GET', 'api/getProviderMessages' + '?idProvider=' + idProvider)
        .then(response => {
          var data = response.data
          this.messageLength = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          if (data) {
            this.rubros = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
      },
      compareStatusMessages (a, b) {
        if (a.messages.length === 0) {
          return 1
        }
        if (b.messages.length === 0) {
          return -1
        }
        if (a.messages[a.messages.length - 1].status < b.messages[b.messages.length - 1].status) {
          return -1
        } else if (a.messages[a.messages.length - 1].status > b.messages[b.messages.length - 1].status) {
          return 1
        }
        return 0
      },
      sortMessagesPerDate (messages) {
        return messages.sort((a, b) => {
          const lastMessageA = a.messages && a.messages.length > 0 ? new Date(this.getMostRecentMessage(a.messages).date) : new Date(0)
          const lastMessageB = b.messages && b.messages.length > 0 ? new Date(this.getMostRecentMessage(b.messages).date) : new Date(0)
          return lastMessageB - lastMessageA
        })
      },
      getMostRecentMessage (messages) {
        const mostRecentMessage = messages.reduce((previous, current) => {
          const previousDate = new Date(previous.date)
          const currentDate = new Date(current.date)
          return previousDate > currentDate ? previous : current
        })
        return mostRecentMessage
      },
      orderByDate (a, b) {
        if (a.date < b.date) {
          return -1
        } else {
          return 1
        }
      },
      formatMessage (msg) {
        if (msg === null) {
          return 'N/A'
        }
        return msg.replace(/\n/g, ' <br/> ')
      },
      formatDate (date) {
        var mydate = new Date(date)
        var month = ['Ene.', 'Feb.', 'Mar.', 'Abr.', 'May.', 'Jun.', 'Jul.', 'Ago.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'][mydate.getMonth()]
        var str = mydate.getHours() + ':' + (mydate.getMinutes() >= 10 ? mydate.getMinutes() : '0' + mydate.getMinutes())
        if (!(this.datetime.getDate() === mydate.getDate() && this.datetime.getMonth() === mydate.getMonth() && this.datetime.getYear() === mydate.getYear())) {
          str = mydate.getDate() + ' ' + month
        }
        return str
      },
      seeMessage (row) {
        this.message = row
        this.conversation = row.messages.sort(this.orderByDate)
        this.showModalMessage = true
        this.updateMsgStatus(row.idUser, 1)
        this.providersMessages = this.sortMessagesPerDate(this.$store.state.provMessages)
      },
      openMassiveMessage () {
        this.showModalMassiveMessageRecipients = false
        this.showModalMassiveMessage = true
      },
      selectMassiveMessageRecipients () {
        this.showModalMassiveMessageRecipients = true
      },
      updateMsgStatus (idProvider, mode) {
        if (this.myMessages.length > 0) {
          if (this.myMessages.filter(el => el.status === '0' && el.idReceptor === this.idUser).length === 0) {
            return
          }
        }
        if (this.providersMessages.length > 0 && this.providersMessages.find(el => el.idUser === idProvider).messages) {
          // console.log(this.provMessages)
          if (this.providersMessages.find(el => el.idUser === idProvider).messages.filter(msg => msg.status === '0' && msg.idEmisor === idProvider).length === 0) {
            return
          }
        }
        api.request('GET', 'api/statusMessages/' + idProvider + '/' + mode)
        .then(response => {
          this.$parent.checkComments()
        })
      },
      updateScroll (id) {
        let element = document.getElementById(id)
        element.scrollTop = element.scrollHeight + 100
        this.loadMessagesFlag = true
        // this.timmerMessage = setInterval(() => this.$parent.checkComments(this.currentPage, this.pageSize), 1000 * 3)
      },
      closeMessage () {
        this.showModalMessage = false
        this.conversation = null
        this.loadMessagesFlag = false
        clearInterval(this.timmerMessage)
        this.timmerMessage = 0
      },
      sendMessage (id) {
        this.newMessage = this.newMessage.trim().replace(/^\s+|\s+$/g, '')
        if (this.newMessage === '') {
          return
        }
        this.loadingMsg = true
        api.request('POST', 'api/sendMessages', {'idEmisor': this.idUser, 'idReceptor': id, 'message': this.newMessage, 'messageType': 1})
        .then(response => {
          this.$parent.checkComments().then(() => {
            if (this.providersMessages.length > 0) {
              this.conversation = this.providersMessages.find(el => el.idUser === this.message.idUser).messages
              this.updateMsgStatus(id, 1)
            }
            if (this.myMessages.length > 0) {
              this.updateMsgStatus(this.idUser, 2)
            }
            this.currentPage = 1
            this.loadingMsg = false
            this.newMessage = ''
            // console.log(document.getElementById('messages-container').scrollTop = document.getElementById('messages-container').scrollHeight)
            setTimeout(() => this.updateScroll('messages-container'), 1)
          })
          let lastMessageDate
          if (this.user.isProvider) {
            lastMessageDate = Date.parse(this.myMessages[this.myMessages.length - 1].date, 'Y-m-d h:m:s')
          } else {
            lastMessageDate = this.conversation[this.conversation.length - 1] ? Date.parse(this.conversation[this.conversation.length - 1].date, 'Y-m-d h:m:s') : null
          }
          let currentDate = new Date()
          if ((currentDate - lastMessageDate) / 1000 > 7200) {
            api.request('GET', 'api/enviarMailMensajeNuevo/' + id)
          }
        })
      },
      sendMassiveMessage (providers) {
        this.showModalMassiveMessage = false
        this.newMessage = this.newMessage.trim().replace(/^\s+|\s+$/g, '')
        if (this.newMessage === '') {
          return
        }
        this.loadingMsg = true
        api.request('POST', 'api/sendMassiveMessages', {'idEmisor': this.idUser, 'idReceptor': providers, 'message': this.newMessage, 'messageType': 1})
        .then(response => {
          this.$parent.checkComments().then(() => {})
          this.$message({
            message: 'El mensaje masivo se ha enviado correctamente.',
            type: 'success'
          })
          //  api.request('GET', 'api/enviarMailMensajeNuevo/' + id)
        })
      }
    },
    beforeMount () {
      // this.checkComments()
      this.getRubros()
    },
    mounted () {
      if (this.myMessages.length > 0) {
        setTimeout(this.updateScroll('messages-container'), 1)
        setTimeout(this.updateMsgStatus(this.idUser, 2), 1)
      }
      if (this.user.isProvider) {
        this.timmerMessage = setInterval(() => this.$parent.checkComments(this.currentPage, this.pageSize), 1000 * 3)
      }
    },
    beforeRouteLeave (to, from, next) {
      this.closeMessage()
      next()
    }
}
</script>

<style>
  .datetime-picker input {
    height: 4em !important;
  }

  .el-table .cell {
    text-overflow: ellipsis;
    white-space: nowrap !important;
  }

  .messages-container {
    height: calc(100vh - 177px);
    overflow: auto !important;
    background-color: #EEE;
    border: 1px #DDD solid;
    border-radius: 3px;
  }

  .messages-rec {
    background-color: #FFF;
    border: 1px #EEE solid;
    border-radius: 3px;
    max-width: 90%;
    padding: 5px 10px;
    margin-bottom: 5px;
    float:left;
    width: max-content;
    word-wrap: break-word;
  }

  .messages-env {
    background-color: #909090;
    color: #FFF;
    border: 1px #EEE solid;
    border-radius: 3px;
    margin-left: 10%;
    max-width: 90%;
    padding: 5px 10px;
    margin-bottom: 5px;
    float:right;
    width: max-content;
    word-wrap: break-word;
  }
  .messages-footer {
    background-color: #FFF;
    width: 100%;
    height: 71px;
  }
  .filter {
    margin: 10px 25px -15px;
  }

</style>



// WEBPACK FOOTER //
// AllComments.vue?71282932